"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var TextTooltip_1 = require("../../../summary/components/common/TextTooltip/TextTooltip");
var Help_1 = require("@material-ui/icons/Help");
var GenericInputStyles_1 = require("./GenericInputStyles");
exports.GenericInputLabel = function (_a) {
    var id = _a.id, label = _a.label, required = _a.required, tooltip = _a.tooltip;
    var styles = GenericInputStyles_1.default();
    return (<core_1.Box display={'flex'}>
      <core_1.Typography component={'span'} variant={'subtitle1'}>
        <core_1.InputLabel htmlFor={id} required={required} className={styles.label} data-test={"text_input:label:" + id}>
          {label}
        </core_1.InputLabel>
      </core_1.Typography>
      {tooltip && (<TextTooltip_1.default id={id} text={tooltip} content={<core_1.Box component={'span'}>
              <Help_1.default color="primary" viewBox="0 0 28 28" fontSize="small"/>
            </core_1.Box>}/>)}
    </core_1.Box>);
};
